<ng-container *transloco="let convert;">
  @if (hasSavedSearches) {
    <div [id]="'saved-search-summary-dropdown' + componentId" class="saved-search-summary-dropdown d-inline-block ms-md-5 ms-0">
      <div (keydown.escape)="showDropDown.set(false)">
        <button type="button" class="drop-toggle bg-white text-start" [disabled]="disabled()" [attr.aria-expanded]="showDropDown()"
          [attr.aria-label]="totalSelected + ' ' + convert('common.of') + ' ' + maxSelectedItems + ' ' + convert('profileManagement.userContact.textSelected')"
          data-test-id="saved-search-summary-dropdown-toggle" (click)="toggleDropdown()">
          <span>{{ totalSelected }} {{ convert('common.of') }} {{ maxSelectedItems }} {{ convert('profileManagement.userContact.textSelected') }}</span>
          <em class="allycon-glyph-chevron-down text-primary ms-2" aria-hidden="true"></em>
        </button>
        @if (showDropDown()) {
          <div class="control-wrapper form-group drop-show bg-white position-absolute overflow-auto" #checkboxes>
            <trap-focus [enableFocusTrap]="showDropDown()" [enableArrowKeys]="true">
              <fieldset [attr.aria-label]="convert('profileManagement.userContact.ariaLabelSavedSearchSelection')">
                <legend hidden>{{ convert('profileManagement.userContact.ariaLabelSavedSearchSelection') }}</legend>
                @for (savedSearch of savedSearches; track savedSearch.id) {
                  <div class="custom-control custom-checkbox checkboxes">
                    <input type="checkbox" class="custom-control-input" [id]="'saved-search-' + savedSearch.id"
                      [checked]="isSelected(savedSearch)"
                      [disabled]="!isSelected(savedSearch) && isMaxSelectionReached"
                      (change)="toggleSelection(savedSearch)"
                      [attr.data-test-id]="'saved-search-summary-checkbox-' + savedSearch.id" />
                    <label class="custom-control-label checkbox-labels text-truncate" [for]="'saved-search-' + savedSearch.id">{{ savedSearch.searchName }}</label>
                  </div>
                }
              </fieldset>
            </trap-focus>
          </div>
        }
      </div>
    </div>
  } @else {
    <span data-test-id="saved-search-summary-empty-state" class="saved-search-summary-empty-state ms-md-5 ms-0">
      ({{ convert('profileManagement.userContact.textToEnable') }}
      <a routerLink="/search" data-test-id="saved-search-summary-create-link">{{ convert('profileManagement.userContact.linkCreateSavedSearch') }}</a>)
    </span>
  }
</ng-container>
